import { render } from "./Projects.vue?vue&type=template&id=2357f63b&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=2357f63b&lang=scss&scoped=true"

import exportComponent from "/Users/ntt/Documents/projects/foxartbox.com/www/fab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2357f63b"]])

export default __exports__